import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { addFormData, fetchAllDashboardDataAPI } from '../../utils/api';

const MostPopularOrderLocation = () => {
    const centerid = localStorage.getItem('centerdata');
    const [toplocation, setTopLocation] = useState([])

    useEffect(() => {
        getTopAgent(centerid)
    }, [centerid])

    const getTopAgent = (centerid) => {
        fetchAllDashboardDataAPI('center-get-top-selling-location-dashboard-data', centerid).then((resp) => {
            if (resp.data.status === 1) {
                setTopLocation(...[resp.data.toplocation])
            }
        })
    }
    const handleInputs = e => {
        const data = { valuetype: e.target.value, centerid: centerid }
        addFormData('center-get-top-selling-location-date-dashboard-data', data).then((resp) => {
            if (resp.data.status === 1) {
                setTopLocation(...[resp.data.toplocation])
            }
        })
    }

    return (
        <div className="topagentproduct card radius-10 overflow-hidden w-100">
            <div className="card-header border-bottom bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="headingtitle">
                        <h6>Most Popular Order Location</h6>
                    </div>
                    <div className="select">
                        <Form.Select
                            placeholder="Member Type"
                            name="top_location"
                            className="topagentselect"
                            onChange={handleInputs}
                        >
                            <option value="Today">Today</option>
                            <option value="Yesterday">Yesterday</option>
                            <option value="Week">Week</option>
                            <option value="Month">Month</option>
                        </Form.Select>
                    </div>
                </div>
            </div>
            <div className="topagentproductsection">
                {toplocation?.map((toplocation, index) => (
                    <div className="agentbody" key={index}>
                        <span className="name">{toplocation?.order_state}</span>
                        <span className="name">{toplocation?.total_count}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default MostPopularOrderLocation